import { EditorWorkspace } from '../components/EditorWorkspace';

export default function TestPage() {
  return (
    <div style={{ width: '100vw', height: '100vh', background: '#f0f0f0' }}>
      <h1 style={{ padding: '20px', margin: 0 }}>Test Page</h1>
      <EditorWorkspace
        sectionId="weaknesses"
        onSectionChange={() => {}}
        onGenerateDraft={() => {}}
        onRegenerateDraft={() => {}}
        onInsertBlock={() => {}}
        onCompletenessCheck={() => {}}
        darkMode={false}
      />
    </div>
  );
}
